
function PageNumber($, totalPageNumber){
	var me = this;

	me.changed = function( currentPage ){
		$('.pageNumber .currentPageNumber').html( currentPage );
		me.updateStepper(currentPage);
	};

	me.updateStepper = function( currentPage ){
		var items = $('.trusty-stepper .trusty-stepper__item');
		items.removeClass('active');
		items.eq(currentPage - 1).addClass('active');
	};

	me.onReady = function(totalPageNumber){
		$('.totalPageNumber').html(totalPageNumber);
		me.updateStepper(1);
	};
	me.onReady(totalPageNumber);
}

